import { graphql } from '@/gql'

export const ANNOUNCEMENT_CREATE = graphql(`
  mutation CreateAnnouncement(
    $userId: UUID!
    $companyId: UUID!
    $departmentIds: [UUID!]
    $systemAnnouncement: Boolean!
    $title: String!
    $teaser: String
    $content: String
    $url: String
    $addPlayIcon: Boolean
    $locales: [String!]
    $popup: Boolean
    $published: Boolean
    $active: Boolean
    $publishAt: Datetime
    $expireAt: Datetime
  ) {
    createAnnouncement(
      input: {
        announcement: {
          userId: $userId
          companyId: $companyId
          departmentIds: $departmentIds
          systemAnnouncement: $systemAnnouncement
          title: $title
          teaser: $teaser
          content: $content
          url: $url
          addPlayIcon: $addPlayIcon
          locales: $locales
          popup: $popup
          published: $published
          active: $active
          publishAt: $publishAt
          expireAt: $expireAt
        }
      }
    ) {
      announcement {
        ...Announcement
      }
    }
  }
`)

export const ANNOUNCEMENT_UPDATE = graphql(`
  mutation UpdateAnnouncement(
    $id: UUID!
    $departmentIds: [UUID!]
    $systemAnnouncement: Boolean!
    $title: String!
    $teaser: String
    $content: String
    $url: String
    $addPlayIcon: Boolean
    $locales: [String!]
    $popup: Boolean
    $published: Boolean
    $active: Boolean
    $publishAt: Datetime
    $expireAt: Datetime
  ) {
    updateAnnouncementById(
      input: {
        id: $id
        patch: {
          departmentIds: $departmentIds
          systemAnnouncement: $systemAnnouncement
          title: $title
          teaser: $teaser
          content: $content
          url: $url
          addPlayIcon: $addPlayIcon
          locales: $locales
          popup: $popup
          published: $published
          active: $active
          publishAt: $publishAt
          expireAt: $expireAt
        }
      }
    ) {
      announcement {
        ...Announcement
      }
    }
  }
`)

export const ANNOUNCEMENT_DELETE = graphql(`
  mutation DeleteAnnouncement($id: UUID!) {
    updateAnnouncementById(input: { id: $id, patch: { active: false } }) {
      announcement {
        id
        title
      }
    }
  }
`)

export const THUMBNAIL_UPLOAD = graphql(`
  mutation uploadThumbnail(
    $base64: String
    $filename: String
    $mimetype: String
  ) {
    FileUploadPublic(
      input: { base64: $base64, filename: $filename, mimetype: $mimetype }
    ) {
      filename
      mimetype
      url
    }
  }
`)

export const READ_ANNOUNCEMENT = graphql(`
  mutation readAnnouncement($userId: UUID!, $announcementId: UUID!) {
    createUserAnnouncement(
      input: {
        userAnnouncement: { userId: $userId, announcementId: $announcementId }
      }
    ) {
      clientMutationId
    }
  }
`)

export const READ_ALL_ANNOUNCEMENTS = graphql(`
  mutation announcementReadAll {
    announcementReadAll(input: {}) {
      clientMutationId
    }
  }
`)
